
export default {
  props: ['videoId', 'image'],
  data () {
    return {
      showIframe: false
    }
  },
  computed: {
    previewImageUrl () {
      if (this.image) {
        return this.image
      } else {
        return `https://img.youtube.com/vi/${this.videoId}/sddefault.jpg`
      }
    },
    videoUrl () {
      return `https://www.youtube.com/embed/${this.videoId}?rel=0&showinfo=0&autoplay=1`
    }
  },
  methods: {
    playVideo () {
      this.showIframe = true
    }
  }
}
